import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStateHandlers from 'recompose/withStateHandlers';
import lifecycle from 'recompose/lifecycle';
import defaultProps from 'recompose/defaultProps';
import { on, off, isElementVisible } from 'utils/dom/dom';
import classnames from 'classnames';

const VIEWPORT_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'load'];
export const DEFAULT_DELAY = 1000;

export const enhance = compose(
	defaultProps({
		delay: DEFAULT_DELAY,
		percentVisible: 100
	}),
	withStateHandlers(() => ({
		el: null,
		isVisible: false,
		triggered: false
	}), {
		getRef: () => (element) => ({
			el: element
		}),
		setTriggered: () => () => ({
			triggered: true
		}),
		handleViewportChange: ({ el, triggered }, { percentVisible }) => () => (
			triggered ? null : ({ isVisible: isElementVisible(el, percentVisible) })
		)
	}),
	lifecycle({
		componentDidMount() {
			on(VIEWPORT_EVENTS, this.props.handleViewportChange);
			this.props.handleViewportChange();
		},
		componentWillUnmount() {
			off(VIEWPORT_EVENTS, this.props.handleViewportChange);
			clearTimeout(this.triggerTimeout);
		},
		componentDidUpdate(prevProps) {
			if (this.props.triggered) {
				return;
			}

			if (!prevProps.isVisible && this.props.isVisible) {
				this.triggerTimeout = setTimeout(() => {
					this.props.setTriggered();
					this.props.onVisible(this.props.delay);
				}, this.props.delay);
			}

			if (prevProps.isVisible && !this.props.isVisible) {
				clearTimeout(this.triggerTimeout);
			}
		}
	})
);

export function ViewportAction({ children, getRef, className }) {
	return (
		<div ref={getRef} className={classnames('viewport-action', className)}>
			{children}
		</div>
	);
}

ViewportAction.propTypes = {
	getRef: PropTypes.func,
	children: PropTypes.node,
	className: PropTypes.string
};

export default enhance(ViewportAction);
